'use client';

import { c as _c } from "react/compiler-runtime";
import { PlayCircleIcon } from '@heroicons/react/24/solid';
import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import { Carousel } from '@src/components/Carousel/Carousel';
import { BrightcovePlayer } from '@src/components/VideoPlayer/BrightcovePlayer';
interface MediaItem {
  mediaType: 'photo' | 'video';
  desktopImgSrc?: string;
  mobileImgSrc?: string;
  brightcoveVideoId?: string;
  videoThumbnailImgSrc?: string;
  videoPlayerAspectRatio?: '16 / 9' | '9 / 16';
  alt?: string;
}
interface MediaGallery {
  mediaItems: MediaItem[];
}
function MediaItem(t0) {
  const $ = _c(6);
  const {
    mediaItem
  } = t0;
  if (mediaItem?.mediaType === "photo" && mediaItem?.desktopImgSrc) {
    const t1 = mediaItem.alt ?? "";
    let t2;
    if ($[0] !== mediaItem.desktopImgSrc || $[1] !== t1) {
      t2 = <Image className="rounded-[30px]" src={mediaItem.desktopImgSrc} alt={t1} width={662} height={662} />;
      $[0] = mediaItem.desktopImgSrc;
      $[1] = t1;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  if (mediaItem?.mediaType === "video" && mediaItem?.brightcoveVideoId) {
    const t1 = mediaItem?.brightcoveVideoId;
    const t2 = mediaItem?.videoPlayerAspectRatio;
    let t3;
    if ($[3] !== t1 || $[4] !== t2) {
      t3 = <BrightcovePlayer videoId={t1} videoPlayerAspectRatio={t2} isMuted={false} autoplay={false} />;
      $[3] = t1;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  return null;
}
export function MediaGallery(t0) {
  const $ = _c(26);
  const {
    mediaItems: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const mediaItems = t2;
  const [selectedMediaItem, setSelectedMediaItem] = useState();
  let t3;
  if ($[2] !== mediaItems[0]) {
    t3 = () => {
      setSelectedMediaItem(mediaItems[0]);
    };
    $[2] = mediaItems[0];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== mediaItems) {
    t4 = [mediaItems];
    $[4] = mediaItems;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] !== mediaItems) {
    t5 = mediaItems.map(_temp);
    $[6] = mediaItems;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      position: "Outside Slider",
      selectedColor: "#000",
      deselectedColor: "#ccc"
    };
    t7 = {};
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [];
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t5) {
    t9 = <div className="lg:hidden"><Carousel slides={t5} overflowMobile={true} showArrows={false} alignmentMobile="center" dotsStyle={t6} builderBlock={t7} slidesPerView={1} attributes={t8} /></div>;
    $[11] = t5;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== mediaItems) {
    let t11;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = (mediaItem_0, index_0) => <div className="w-full overflow-hidden rounded-lg" role="presentation" key={`${index_0}`} onClick={() => setSelectedMediaItem(mediaItem_0)}>{mediaItem_0?.desktopImgSrc && <Image src={mediaItem_0.desktopImgSrc} alt={mediaItem_0.alt ?? ""} height={100} width={100} />}{mediaItem_0?.mediaType === "video" && mediaItem_0?.brightcoveVideoId && <div className="relative flex size-[100px] items-center justify-center">{mediaItem_0?.videoThumbnailImgSrc && <Image src={mediaItem_0?.videoThumbnailImgSrc} alt={mediaItem_0.alt ?? ""} height={100} width={100} />}<div className="absolute top-0 size-[100px] rounded-lg bg-bodi-gray-medium opacity-50" /><div className="absolute top-0 flex size-[100px] items-center justify-center rounded-lg"><PlayCircleIcon fill="white" fillOpacity={0.8} className="size-9" /></div></div>}</div>;
      $[15] = t11;
    } else {
      t11 = $[15];
    }
    t10 = mediaItems.map(t11);
    $[13] = mediaItems;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[16] !== t10) {
    t11 = <div className="w-[102px]"><div className="flex cursor-pointer flex-col gap-2">{t10}</div></div>;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== selectedMediaItem) {
    t12 = <div className="flex w-full max-w-full flex-col"><MediaItem mediaItem={selectedMediaItem} /></div>;
    $[18] = selectedMediaItem;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t11 || $[21] !== t12) {
    t13 = <div className="mb-6 hidden lg:flex lg:gap-8">{t11}{t12}</div>;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13 || $[24] !== t9) {
    t14 = <div className="mb-4 lg:mb-0">{t9}{t13}</div>;
    $[23] = t13;
    $[24] = t9;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
}
function _temp(mediaItem, index) {
  return <div className="flex size-full items-center justify-center" key={`${index}`}>{mediaItem?.mediaType === "photo" && mediaItem?.mobileImgSrc && <Image className="w-full max-w-[85vw] rounded-[30px] object-contain" src={mediaItem?.mobileImgSrc} alt={mediaItem.alt ?? ""} width={332} height={332} />}{mediaItem?.mediaType === "video" && mediaItem?.brightcoveVideoId && <BrightcovePlayer videoId={mediaItem?.brightcoveVideoId} videoPlayerAspectRatio={mediaItem?.videoPlayerAspectRatio} isMuted={false} autoplay={false} />}</div>;
}